import { render, staticRenderFns } from "./performance-by-grade.vue?vue&type=template&id=6c9071f4"
import script from "./performance-by-grade.ts?vue&type=script&lang=ts&external"
export * from "./performance-by-grade.ts?vue&type=script&lang=ts&external"
import style0 from "./performance-by-grade.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports